import Component from './sidebar-check-list';
export default Component;
